/**
 * @module support/pdl
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// tslint:disable

import { Input, Injectable, OnDestroy, OnInit } from '@angular/core';
import { NgRadio } from '../components/ng-radio.component';
import { Subscription } from 'rxjs';
import { PdlEventDataObject } from '../interfaces/pdl-data.interface';
// import { InjectablePDLService } from '../services/injectablepdl.service';
import { ActivatedRoute } from '@angular/router';
import { PdlService } from '../services/pdl.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';

@Injectable()
export abstract class PDLBaseComponent implements OnInit, OnDestroy {
  @Input() public pdlPageComponentId: string;
  @Input() public pdlRepeatedComponent: string;

  private eventBus: NgRadio;
  private captureEventSubscription: Subscription;
  private isScreen: boolean;
  private pdlBaseCommonUtil: CommonUtilService;

  constructor(
    public pdlService: PdlService,
    routeSnapshot: ActivatedRoute
  ) {
    this.isScreen = false;
    this.eventBus = this.pdlService.getEventBus();
    this.pdlBaseCommonUtil = new CommonUtilService();
    if (routeSnapshot?.snapshot?.data['pdlPageComponentId']) {
      this.pdlPageComponentId = routeSnapshot.snapshot.data['pdlPageComponentId'];
      this.isScreen = true;
      delete routeSnapshot.snapshot.data['pdlPageComponentId'];
    }
    if (!this.pdlPageComponentId) {
      const currentDate = `${new Date().getTime()}_${this.pdlBaseCommonUtil.generateRandomId()}`;
      this.pdlPageComponentId = this.constructor.name.concat(currentDate.toString());
    }
    // this.pdlPageComponentId = !this.pdlPageComponentId ? this.constructor.name : this.pdlPageComponentId;

    this.captureEventSubscription = this.eventBus
      .on('pdl:capture-data-event')
      .subscribe((message: PdlEventDataObject) => {
        if (this.pdlPageComponentId === message.cmpId) {
          this.pdlService.populateEventObject(message, this);
        }
      });
  }

  public ngOnInit(): void {
    // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'component_init');
    if (this.isScreen) {
      //this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'pageLoad');
    }
  }

  public ngOnDestroy(): void {
    this.pdlService.persistData(this.pdlPageComponentId, this, 2000);
    this.captureEventSubscription.unsubscribe();
  }
}
